<div
    bsModal
    #createOrEditModal="bs-modal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="createOrEditModal"
    aria-hidden="true"
    [config]="{ backdrop: 'static' }"
>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form #currencyForm="ngForm" novalidate (ngSubmit)="save()" autocomplete="off">
                <div class="modal-header">
                    <h4 class="modal-title">
                        <span *ngIf="currency.id">{{ l('EditCurrency') }}</span>

                        <span *ngIf="!currency.id">{{ l('CreateNewCurrency') }}</span>
                    </h4>

                    <button
                        type="button"
                        class="btn-close"
                        (click)="close()"
                        aria-label="Close"
                        [disabled]="saving"
                    ></button>
                </div>
                <div class="modal-body">
                    <div class="row mt-3">
                        <div class="col-md-6">
                            <div class="my-3">
                                <label class="form-label" for="Currency_Code">{{ l('Code') }} *</label>
                                <input
                                    type="text"
                                    #Currency_Code="ngModel"
                                    id="Currency_Code"
                                    class="form-control"
                                    [(ngModel)]="currency.code"
                                    name="Code"
                                    minlength="0"
                                    maxlength="50"
                                    required
                                />
                                <validation-messages [formCtrl]="Currency_Code"></validation-messages>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="my-3">
                                <label class="form-label" for="Currency_Name">{{ l('Name') }} *</label>
                                <input
                                    type="text"
                                    #Currency_Name="ngModel"
                                    id="Currency_Name"
                                    class="form-control"
                                    [(ngModel)]="currency.name"
                                    name="Name"
                                    minlength="0"
                                    maxlength="500"
                                    required
                                />
                                <validation-messages [formCtrl]="Currency_Name"></validation-messages>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="my5">
                                <label class="form-label" for="Currency_Rate">{{ l('Rate') }}</label>
                                <input
                                    type="number"
                                    #Currency_Rate="ngModel"
                                    id="Currency_Rate"
                                    class="form-control"
                                    [(ngModel)]="currency.rate"
                                    name="Rate"
                                />
                                <validation-messages [formCtrl]="Currency_Rate"></validation-messages>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <br />
                            <br />
                            <label class="form-check form-check-custom form-check-solid">
                                <input
                                    id="Currency_IsPrimary"
                                    #Currency_IsPrimary="ngModel"
                                    name="IsPrimary"
                                    [(ngModel)]="currency.isPrimary"
                                    type="checkbox"
                                    class="form-check-input"
                                />
                                <span class="form-check-label">
                                    {{ l('IsPrimary') }}
                                </span>
                            </label>
                            <validation-messages [formCtrl]="Currency_IsPrimary"></validation-messages>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button [disabled]="saving" type="button" class="btn btn-default" (click)="close()">
                        {{ l('Cancel') }}
                    </button>
                    <button
                        type="submit"
                        class="btn btn-primary blue"
                        [disabled]="!currencyForm.form.valid"
                        [buttonBusy]="saving"
                        [busyText]="l('SavingWithThreeDot')"
                    >
                        <i class="fa fa-save"></i>
                        <span>{{ l('Save') }}</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
